var rtl_default = {
  "rtl": "bhpDG",
  "ltr": "ib0zn"
};
export {
  rtl_default as default
};
//# sourceMappingURL=rtl-scss.js.map
